////
/// @group Components
////

export interface IRedirect {
  /** @description Elements */
  el: {
    dropdown: NodeListOf<HTMLElement>
  }

  /** @description Listen for the change event on dropdowns */
  init: () => void

  /** @description Redirect the page */
  handleRedirect: (event) => void
}

const Redirect = {
  el: {
    dropdown: document.querySelectorAll("[data-action='redirect']"),
  },

  init() {
    if (Redirect.el.dropdown) {
      Redirect.el.dropdown.forEach((redirect) => {
        redirect.addEventListener('change', Redirect.handleRedirect)
      })
    }
  },

  handleRedirect(event) {
    document.location = event.target.value
  },
}

export default Redirect
